module.exports = __webpack_public_path__ + "static/assets/b757d5b397edb5106c75f5823d3cb8ff.png";